import React, { useState, useEffect } from 'react';
import './LicenciaBlockScreen.css';
import { waitForApiUrl } from '../../utils/api';

const LicenciaBlockScreen = ({ onLicenciaActivada, mensaje }) => {
  const [claveLicencia, setClaveLicencia] = useState('');
  const [urlServidor, setUrlServidor] = useState('');
  const [procesando, setProcesando] = useState(false);
  const [error, setError] = useState(mensaje || '');
  const [apiLocal, setApiLocal] = useState('Cargando...');

  useEffect(() => {
    waitForApiUrl().then(url => setApiLocal(url));
  }, []);

  const handleActivar = async () => {
    if (!claveLicencia.trim()) {
      setError('Ingrese una clave de licencia');
      return;
    }
    if (!urlServidor.trim()) {
      setError('Ingrese la URL del servidor remoto');
      return;
    }

    try {
      setProcesando(true);
      setError('');

      let machineId = 'web-' + navigator.userAgent.length + '-' + (navigator.hardwareConcurrency || 0);
      let nombrePC = 'Navegador';
      if (window.licenciaAPI) {
        const result = await window.licenciaAPI.getMachineId();
        if (result.success) {
          machineId = result.machineId;
          nombrePC = result.nombrePC;
        }
      }

      // Llamar a la API LOCAL, que internamente contacta al servidor remoto
      const response = await fetch(apiLocal, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: 'activarLicencia',
          clave_licencia: claveLicencia,
          machine_id: machineId,
          nombre_pc: nombrePC,
          url_servidor: urlServidor
        })
      });

      const result = await response.json();

      if (result.success) {
        if (onLicenciaActivada) {
          onLicenciaActivada(result.data);
        }
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError('Error de conexion con la API local: ' + err.message);
    } finally {
      setProcesando(false);
    }
  };

  return (
    <div className="licencia-block-overlay">
      <div className="licencia-block-card">
        <div className="licencia-block-icon">
          <svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="#dc3545" strokeWidth="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <h1 className="licencia-block-title">Licencia Requerida</h1>
        <p className="licencia-block-subtitle">
          {mensaje || 'Active una licencia valida para usar PrestoClassic 2.0'}
        </p>
        <p className="licencia-block-api-url">
          API Local: <span>{apiLocal}</span>
        </p>

        {error && (
          <div className="licencia-block-error">{error}</div>
        )}

        <div className="licencia-block-form">
          <div className="licencia-block-field">
            <label>URL del Servidor Remoto (API)</label>
            <input
              type="text"
              value={urlServidor}
              onChange={(e) => setUrlServidor(e.target.value)}
              placeholder="https://miservidor.com/api_prestov2/reportes/funciones_php/api.php"
            />
          </div>

          <div className="licencia-block-field">
            <label>Clave de Licencia</label>
            <input
              type="text"
              value={claveLicencia}
              onChange={(e) => setClaveLicencia(e.target.value.toUpperCase())}
              placeholder="PRESTO-XXXX-XXXX-XXXX"
              style={{ fontFamily: 'monospace', letterSpacing: '2px' }}
            />
          </div>

          <button
            className="licencia-block-btn"
            onClick={handleActivar}
            disabled={procesando}
          >
            {procesando ? 'Activando...' : 'Activar Licencia'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LicenciaBlockScreen;
